














































































































































































import Vue from 'vue';

import List from '@/models/soukai/List';
import SolidUser from '@/models/users/SolidUser';
import Workspace from '@/models/soukai/Workspace';

import AppInfo from '@/components/AppInfo.vue';
import AppNavigationOverlay from '@/components/AppNavigationOverlay.vue';

export default Vue.extend({
    components: {
        AppInfo,
        AppNavigationOverlay,
    },
    computed: {
        centerAvatar(): boolean {
            return this.isClosed && !this.$ui.mobile;
        },
        userInfo(): string | void {
            // TODO this should be moved to a dedicated section with more information
            // about the user
            if (this.$auth.user instanceof SolidUser) {
                return 'WebID: ' + this.$auth.user.id;
            }
        },
        isOpen(): boolean {
            return this.$ui.navigationDrawerOpen;
        },
        isClosed(): boolean {
            return !this.isOpen;
        },
        lists(): List[] {
            const activeWorkspace = this.$workspaces.active;

            return activeWorkspace
                ? [
                    activeWorkspace.inbox,
                    ...(activeWorkspace.lists || []),
                ]
                : [];
        },
    },
    created() {
        this.$ui.setNavigationDrawerOpen(!this.$ui.mobile);
    },
    methods: {
        createWorkspace() {
            this.$ui.openDialog(() => import('@/dialogs/WorkspaceForm.vue'));
            this.closeDrawerOnMobile();
        },
        createWorkspaceList() {
            this.$ui.openDialog(() => import('@/dialogs/ListForm.vue'));
            this.closeDrawerOnMobile();
        },
        async activateWorkspace(workspace: Workspace) {
            if (!workspace.isRelationLoaded('lists')) {
                await this.$ui.wrapAsyncOperation(
                    workspace.loadRelation('lists'),
                    `Loading ${workspace.name}...`,
                );

                // TODO this could be done automatically in Soukai
                for (const list of workspace.lists!) {
                    list.setRelationModels('workspace', workspace);
                }
            }

            if (!workspace.activeList.isRelationLoaded('tasks')) {
                await this.$ui.wrapAsyncOperation(
                    workspace.activeList.loadRelation('tasks'),
                    `Loading ${workspace.activeList.name}...`,
                );
            }

            this.$workspaces.setActive(workspace);
            this.closeDrawerOnMobile();
        },
        async activateList(list: List) {
            if (!list.isRelationLoaded('tasks')) {
                await this.$ui.wrapAsyncOperation(
                    list.loadRelation('tasks'),
                    `Loading ${list.name}...`,
                );
            }

            this.$workspaces.active!.setActiveList(list);
            this.closeDrawerOnMobile();
        },
        editWorkspace(workspace: Workspace) {
            this.$ui.openDialog(
                () => import('@/dialogs/WorkspaceForm.vue'),
                { workspace },
            );

            this.closeDrawerOnMobile();
        },
        editList(list: List) {
            this.$ui.openDialog(
                () => import('@/dialogs/ListForm.vue'),
                { list },
            );

            this.closeDrawerOnMobile();
        },
        closeDrawerOnMobile() {
            if (this.$ui.mobile) {
                this.$ui.setNavigationDrawerOpen(false);
            }
        },
    },
});
